import { ChevronLeft, RefreshCw, LayoutDashboard, BarChart3, Package } from 'lucide-react';
import PanelDateControls from './PanelDateControls';
import BrandLogo from './BrandLogo';

// El tab Catálogo (stock) solo aplica a marcas ecommerce.
function sectionsFor(vertical) {
  const sections = [
    { key: 'summary', label: 'Resumen', Icon: LayoutDashboard },
    { key: 'campaigns', label: 'Campañas y anuncios', Icon: BarChart3 },
  ];
  if (vertical === 'ecommerce') sections.push({ key: 'catalog', label: 'Catálogo', Icon: Package });
  return sections;
}

const VERTICAL_LABEL = { ecommerce: 'Ecommerce', lead_gen: 'Lead gen' };

function updatedTime(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleTimeString('es-UY', { hour: '2-digit', minute: '2-digit' });
}

function SegmentedNav({ sections, section, onSectionChange }) {
  return (
    <div className="inline-flex gap-1 rounded-lg bg-gray-100 p-1">
      {sections.map(({ key, label, Icon }) => {
        const active = section === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onSectionChange(key)}
            className={`inline-flex items-center gap-2 rounded-md px-4 py-1.5 text-sm transition-colors ${
              active
                ? 'bg-white font-medium text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            <Icon className="h-4 w-4" aria-hidden="true" />
            {label}
          </button>
        );
      })}
    </div>
  );
}

/**
 * Encabezado del panel de una marca. Dos filas alineadas: (1) breadcrumb +
 * controles de fecha/compare; (2) identidad de la marca a la izquierda y el
 * segmentado Resumen / Campañas y anuncios a la derecha. Compartido admin (con
 * back + `brandSwitcher`) y cliente (sin ellos).
 */
export default function PanelHeader({
  brand,
  updatedAt,
  dateControls,
  section,
  onSectionChange,
  onBack,
  brandSwitcher,
}) {
  const time = updatedTime(updatedAt);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800"
          >
            <ChevronLeft className="h-4 w-4" aria-hidden="true" />
            Marcas
          </button>
        ) : (
          <span />
        )}
        <div className="flex flex-wrap items-center gap-2">
          {brandSwitcher}
          <PanelDateControls controls={dateControls} showCompare />
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <BrandLogo name={brand?.name} logoUrl={brand?.logo_url} size="lg" />
          <div className="flex flex-col gap-0.5">
            <div className="flex items-center gap-2.5">
              <h1 className="text-xl font-bold text-gray-900">{brand?.name || 'Marca'}</h1>
              {brand?.vertical && (
                <span className="rounded-md bg-gray-100 px-2 py-0.5 text-xs font-medium uppercase tracking-wide text-gray-500">
                  {VERTICAL_LABEL[brand.vertical] ?? brand.vertical}
                </span>
              )}
            </div>
            <span className="inline-flex items-center gap-1.5 text-xs text-gray-400">
              <RefreshCw className="h-3 w-3" aria-hidden="true" />
              Sincronizado 2×/día{time ? ` · última ${time}` : ''}
            </span>
          </div>
        </div>

        <SegmentedNav sections={sectionsFor(brand?.vertical)} section={section} onSectionChange={onSectionChange} />
      </div>
    </div>
  );
}
